<template>
  <div class="wrapper">
    <img v-if="downloadBanner != ''" :src="downloadBanner" class="backgroundImg">
    <img v-if="downloadBanner == ''" src="../assets/img/download_b.jpg" class="backgroundImg">
    <!-- <table style="width: 100%">
      <tr>
        <td style="width: 20%"></td>
        <td style="width: 30%">
          <div class="img-box">
            <div id="downloadQrCode"></div>
            <p class="img-box-title">苹果 + 安卓端下载</p>
          </div>
        </td>
        <td style="width: 30%">
          <div class="img-box-second">
            <div id="downloadQrCodeSecond"></div>
            <p class="img-box-title">苹果TF版下载（防闪退）</p>
          </div>
        </td>
        <td style="width: 20%"></td>
      </tr>
    </table> -->
    <table style="width: 100%; margin-top: 200px; position: absolute; z-index: 1000;">
      <tr>
        <td style="width: 30%"></td>
        <td style="width: 20%">
          <div style="float: right; margin-right: 20px">
            <button class="buttonStyle" @click="showPopup('testflight')">
              <i class="tm-ic ffic-iphone"></i>
              <span style="margin-top: -5px; margin-left: 10px">苹果防闪退版</span>
            </button>
          </div>
        </td>
        <td style="width: 20%">
          <div style="margin-left: 20px">
            <button class="buttonStyle" @click="showPopup('vueandrod')">
              <i class="tm-ic ffic-android"></i>
              <span style="margin-top: -5px; margin-left: 10px">安卓专业版</span>
            </button>
          </div>
        </td>
        <td style="width: 30%"></td>
      </tr>
      <!-- =============================== second line ============================= -->
      <tr>
        <td style="width: 30%"></td>
        <td style="width: 20%">
          <div style="float: right; margin-right: 20px">
            <button class="buttonStyle" @click="showPopup('applefree')">
              <i class="tm-ic ffic-iphone"></i>
              <span style="margin-top: -5px; margin-left: 10px">苹果免升级版</span>
            </button>
          </div>
        </td>
        <td style="width: 20%">
          <div style="margin-left: 20px">
            <button class="buttonStyle" @click="showPopup('androidfree')">
              <i class="tm-ic ffic-android"></i>
              <span style="margin-top: -5px; margin-left: 10px">安卓免升级版</span>
            </button>
          </div>
        </td>
        <td style="width: 30%"></td>
      </tr>
      <!-- ================================ third line ================================ -->
      <tr>
        <td style="width: 30%"></td>
        <td style="width: 20%">
          <div style="float: right; margin-right: 20px">
            <button class="buttonStyle" @click="showPopup('nativeapp_ios')">
              <i class="tm-ic ffic-iphone"></i>
              <span style="margin-top: -5px; margin-left: 10px">苹果经典版</span>
            </button>
          </div>
        </td>
        <td style="width: 20%">
          <div style="margin-left: 20px">
            <button class="buttonStyle" @click="showPopup('nativeapp_android')">
              <i class="tm-ic ffic-android"></i>
              <span style="margin-top: -5px; margin-left: 10px">安卓经典版</span>
            </button>
          </div>
        </td>
        <td style="width: 30%"></td>
      </tr>
      <tr>
        <td style="width: 30%"></td>
        <td style="width: 20%">
          <div style="float: right; margin-right: 20px">
            <button class="buttonStyle" @click="showPopup('pc_mac')">
              <i class="tm-ic mac"></i>
              <span style="margin-top: -5px; margin-left: 10px">MAC桌面端</span>
            </button>
          </div>
        </td>
        <td style="width: 20%">
          <div style="margin-left: 20px">
            <button class="buttonStyle" @click="showPopup('pc_desktop')">
              <i class="tm-ic windows"></i>
              <span style="margin-top: -5px; margin-left: 10px">PC桌面端</span>
            </button>
          </div>
        </td>
        <td style="width: 30%"></td>
      </tr>
    </table>
    <!-- <div class="buttonStyle" style="margin: 0 auto;font-size: 18px;line-height: 40px" @click="showPopup('pc_desktop')">
      <p>
        <i class="el-icon-s-tools"></i>&nbsp;&nbsp;&nbsp;PC桌面端
      </p>
    </div> -->
    <el-dialog id="dialogStyle" :visible.sync="qrPopup" width="450px" center>
      <div class="img-box">
        <div id="downloadQrCodeSecond"></div>
        <p class="img-box-title">{{ popupContent }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "download",
  data() {
    return {
      info: {
        qq: [],
        phone: [],
        codes: [],
      },
      appDownload: "",
      testFlightDownload: "",
      androidPro: "",
      appleFreeUpgrade: "",
      androidFreeUpgrade: "",
      nativeApp: "",
      pc_desktop: '',
      pc_mac: '',
      qrPopup: false,
      popupContent: "",
      qrCode: null,
      downloadBanner: ""
    };
  },
  computed: {},
  methods: {
    showPopup(operate) {
      let that = this;
      switch (operate) {
        case "testflight":
          this.popupContent = "苹果防闪退版";
          this.qrPopup = true;
          setTimeout(() => {
            this.QrCode(this.testFlightDownload);
          }, 300);
          break;
        case "vueandrod":
          this.popupContent = "安卓专业版";
          this.qrPopup = true;
          setTimeout(() => {
            this.QrCode(this.androidPro);
          }, 300);
          break;
        case "applefree":
          this.popupContent = "苹果免升级版";
          this.qrPopup = true;
          setTimeout(() => {
            this.QrCode(this.appleFreeUpgrade);
          }, 300);
          break;
        case "androidfree":
          this.popupContent = "安卓免升级版";
          this.qrPopup = true;
          setTimeout(() => {
            this.QrCode(this.androidFreeUpgrade);
          }, 300);
          break;
        case "nativeapp_android":
          this.popupContent = "安卓经典版";
          this.qrPopup = true;
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "nativeapp_ios":
          this.qrPopup = true;
          this.popupContent = "苹果经典版";
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "pc_desktop":
          // this.popupContent = "桌面版";
          window.open(this.pc_desktop)
          break;
        case "pc_mac":
          // this.popupContent = "桌面版";
          window.open(this.pc_mac)
          break;
        default:
          break;
      }
    },
    QrCode(url) {
      if (this.qrCode) {
        this.qrCode.makeCode(url);
      } else {
        this.qrCode = new QRCode("downloadQrCodeSecond", {
          width: 345,
          height: 345,
          text: url, // 二维码地址
        });
      }
    },
    // QrCodeSecond(url) {
    //   new QRCode("downloadQrCodeSecond", {
    //     width: 345,
    //     height: 345,
    //     text: url,
    //   });
    // },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data;
            // that.QrCode(that.info.codes[0].code);
            that.appDownload = that.info.codes[0].code;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getQRLink() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // that.QrCodeSecond(res.data.data);
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;
            that.pc_desktop = res.data.data.pc_desktop;
            that.pc_mac = res.data.data.pc_mac;
            that.downloadBanner = res.data.data.downgrade_image;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.getInfoData();
    // this.QrCodeSecond();
    this.getQRLink();
  },
};
</script>

<style scoped>
.wrapper {
  /* background: url(../assets/img/bg.png) no-repeat center; */
  /* background-size: cover;
  background-position: 5% 70%; */
  min-width: 1200px;
  height: 720px;
  overflow: hidden;
  position: relative;
}

.backgroundImg{
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.img-box {
  width: 100%;
  opacity: 0.85;
  background: white;
  /* margin: 200px auto; */
  /* padding-top: 20px; */
}

.img-box img {
  width: 100%;
}

.img-box-title {
  text-align: center;
  font-size: 25px;
  padding: 28px 0px 0px 0px;
}

/*.img-box-second {
  width: 400px;
  opacity: 0.85;
  background: white;
  margin: 200px auto;
  padding-top: 20px;
}
.img-box-titl-second {
  text-align: center;
  font-size: 25px;
  padding: 10px 0;
} */

.tm-ic {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  width: 40px;
  height: 40px;
}

.ffic-android {
  background-image: url(../assets/img/icons/ffic-android.png);
}

.ffic-iphone {
  background-image: url(../assets/img/icons/ffic-iphone.png);
}

.buttonStyle {
  width: 200px;
  border-radius: 30px;
  background-color: rgb(255, 69, 0);
  color: rgb(255, 255, 255);
  display: flex;
  height: 50px;
  line-height: 50px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #6c757d;
  font-size: 16px;
  margin: 20px 0px;
}

.windows {
  background-image: url(../assets/img/icons/windows.png);
}

.mac {
  background-image: url(../assets/img/icons/mac.png);
}
</style>

<style>
#dialogStyle .el-dialog__body {
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue